import { GET_FEATURE_CMS_API } from '../commons/constants';
import { FeatureTypes } from '../types/feature.type';
import { PaginationResponseTypes } from '../types/response';
import { get } from './axios';

export const fetchFeaturesApi = async (): Promise<PaginationResponseTypes<FeatureTypes[]>> => {
  let res: PaginationResponseTypes<FeatureTypes[]>;

  const pageDefault = 9999;
  try {
    res = await get(`${GET_FEATURE_CMS_API}`, {
      params: { size: pageDefault },
    });
  } catch (e) {
    console.error(e);
    return null;
  }

  return res;
};
